<template>
  <div id="mb-question" class="mb-question">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <!-- <div v-if="gameState" class="curtain" @click="cancelCheck()"></div> -->
    <div class="mb-question-container" v-if="items[currentQuestion]" :style="questionStyle">
      <div class="mb-question-shadow" :style="[items[currentQuestion].question.style, setQuestionStyle()]">
        <div class="mb-question" :style="[setPadding()]">
          <span v-if="items[currentQuestion].question.text"></span>
          <img
            class="question-img"
            v-if="items[currentQuestion].question.img"
            :src="giveMeImagePlease(items[currentQuestion].question.img.src)"
          />
          <div
            class="question-aduio"
            @mouseenter="iconHover = true"
            @mouseleave="iconHover = false"
            v-if="items[currentQuestion].question.audio"
            @click="controllAudio()"
          >
            <transition name="icon-fade">
              <img draggable="false" v-if="canIPlayASong" :src="titleIcon" />
            </transition>
            <transition name="icon-fade">
              <img draggable="false" v-if="!canIPlayASong || iconHover" :src="titleIconOn" />
            </transition>
          </div>
          <span v-if="items[currentQuestion].question.text" v-html="items[currentQuestion].question.text"></span>
        </div>
      </div>
    </div>
    <div
      class="mb-answers-container"
      v-if="items[currentQuestion].answer"
      :style="[answersStyle, items[currentQuestion].answerStyle]"
    >
      <div
        class="mb-answer-shadow"
        @click="setState(ans, ansIndex)"
        :style="[setAnswerStyle(ans.state), ans.style]"
        :key="currentQuestion + '-mb-answer-shadow-' + ansIndex"
        v-for="(ans, ansIndex) in items[currentQuestion].answer"
      >
        <div class="mb-answer" :style="[setPadding()]">
          <div style="width: 70px; font-weight: bold" v-if="!startGameConfig.noLabel">
            {{ String.fromCharCode(65 + ansIndex) }}.
          </div>
          <div style="width: calc(100%- 70px)" class="mb-answer" v-if="ans.text" v-html="ans.text"></div>
          <div class="mb-answer-img-box" style="width: calc(100%- 70px); text-align: left" :style="ans.style">
            <img class="mb-answer-img" v-if="ans.img" :style="[setPadding()]" :src="giveMeImagePlease(ans.img.src)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-question',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      iconHover: false,
      canIPlayASong: true,
      canIClick: true,
      gameState: false,
      currentQuestion: 0,
      questionStyle: {},
      answersStyle: {},
      items: [],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    setPadding() {
      let style = {};
      if (this.startGameConfig.noPadding) style.padding = '0px !important';
      console.log(style);
      return style;
    },
    setAnswerStyle(state) {
      let style = {};
      let colorBlue = '0 0 0 2px #0aabff,';
      if (this.startGameConfig.noBlueShadow) colorBlue = '';
      if (state == 'check') {
        style.boxShadow = '0 0 0 8px #0aabff,' + colorBlue + ' 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else if (state == 'correct') {
        style.boxShadow = '0 0 0 8px #00d60b,' + colorBlue + ' 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else if (state == 'incorrect') {
        style.boxShadow = '0 0 0 8px #fe0a02,' + colorBlue + ' 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      } else {
        style.boxShadow = '0 0 0 0px transparent,' + colorBlue + ' 0 0 0 16px #ffffff';
        style.borderRadius = '10px';
      }
      return style;
    },
    setQuestionStyle() {
      let style = {};
      let colorBlue = '0 0 0 2px #0aabff,';
      if (!this.startGameConfig.questionNoShadow) {
        if (this.startGameConfig.noBlueShadow) colorBlue = '';
        style.boxShadow = '0 0 0 0px transparent,' + colorBlue + ' 0 0 0 16px #ffffff';
      }

      return style;
    },
    setValue(items, id, it) {
      this.$set(items, id, it);
    },
    setState(ans, id) {
      let it = ans;
      console.log(it);
      if (it.state != 'correct') {
        if (this.canIClick) {
          this.canIClick = false;

          if (it.state) it.state = null;
          else it.state = 'check';
          this.setValue(this.items[this.currentQuestion].answer, id, it);
          if (it.state == 'check') {
            setTimeout(() => {
              if (it.correct) {
                it.state = 'correct';
                this.setValue(this.items[this.currentQuestion].answer, id, it);
                if (this.currentQuestion < this.items.length) {
                  setTimeout(() => {
                    this.checkCurrentQuestion();
                  }, 1000);
                }
                // this.checkGameCorrect();
              } else {
                it.state = 'incorrect';
                this.setValue(this.items[this.currentQuestion].answer, id, it);
              }
              this.canIClick = true;
            }, 1000);
          } else {
            this.canIClick = true;
            setTimeout(() => {
              if (this.currentQuestion < this.items.length) {
                this.checkCurrentQuestion();
              }
            }, 2000);
            // this.checkGameCorrect();
          }
        }
      }
    },
    controllAudio() {
      if (this.items[this.currentQuestion].question.audio) {
        if (this.items[this.currentQuestion].question.audio.playing()) {
          this.items[this.currentQuestion].question.audio.stop();
        } else {
          Howler.stop();
          this.items[this.currentQuestion].question.audio.play();
        }
      }
    },
    checkCurrentQuestion() {
      let value = true;
      this.items[this.currentQuestion].answer.forEach((it) => {
        if (it.state == 'correct') {
          if (!it.correct) value = false;
        }
        if (it.state == 'incorrect') value = false;
        if (it.correct) {
          if (it.state != 'correct') value = false;
        }
      });
      value;
      console.log(value);
      if (value) {
        if (this.currentQuestion == this.items.length - 1) {
          this.gameState = true;
          this.$store.dispatch('checkGame');
        } else {
          if (this.items[this.currentQuestion].question.audio) this.items[this.currentQuestion].question.audio.stop();
          this.currentQuestion = this.currentQuestion + 1;
        }
      }
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    init() {
      let it;
      if (this.startGameConfig.items) {
        it = _.cloneDeep(this.startGameConfig.items);
        if (this.startGameConfig.shuffle) it = this.shuffle(it);
        it.forEach((itm) => {
          if (itm.question.audio) {
            itm.question.audio = new Howl({
              src: this.giveMeImagePlease(itm.question.audio),
              autoplay: false,
              loop: false,
              volume: 0.5,
              onend: () => {
                this.canIPlayASong = true;
              },
              onstop: () => {
                this.canIPlayASong = true;
              },
              onplay: () => {
                this.canIPlayASong = false;
              },
            });
          }
          if (this.startGameConfig.answerShuffle) itm.answer = this.shuffle(itm.answer);
        });
        this.items = it;
      }
      if (this.startGameConfig.questionStyle) this.questionStyle = _.cloneDeep(this.startGameConfig.questionStyle);
      if (this.startGameConfig.answersStyle) this.answersStyle = _.cloneDeep(this.startGameConfig.answersStyle);
    },
    cancelCheck() {
      this.gameState = false;
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameStatus() {
      this.gameState = true;
      if (this.gameState) this.$store.dispatch('checkGame');
    },
    checkGameAction() {
      return this.gameState;
    },
    resetGameAction() {
      this.iconHover = false;
      this.canIPlayASong = true;
      this.canIClick = true;
      this.gameState = false;
      this.currentQuestion = 0;
      this.questionStyle = {};
      this.answersStyle = {};
      this.items = [];
      setTimeout(() => {
        this.init();
      }, 1);
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {
    Howler.stop();
  },
  computed: {
    titleIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-64px.png`);
      } catch {
        console.log(
          '%cTitleIcon MbQuestion - error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    titleIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-on-64px.png`);
      } catch {
        console.log(
          '%cTitleIconOn MbQuestion - error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.curtain
  position: absolute
  top: 0
  width: 1920px
  height: 1080px
  left: 0
  z-index: 2
.mb-question
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  .mb-question-container, .mb-answers-container
    height: 100%
    position: absolute
    top: 0
    // background: green
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
  .mb-question-container
    width: 30%
    left: 0
    .mb-question-shadow
      box-sizing: border-box
      background: #ffffff
      width: 200px
      height: 200px
      // box-shadow: 0 0 0 0px transparent,0 0 0 2px #0aabff, 0 0 0 16px #ffffff
      border-radius: 10px
      .mb-question
        // margin: 30px
        display: flex
        align-items: center
        justify-content: center
        padding: 14px
        background: transparent
        .question-img
          max-width: 100%
          max-height: 100%
          object-fit: scale-down
        .question-aduio
          width: 48px
          height: 48px
          position: relative
          margin: 0 10px
          // background: red
          img
            object-fit: scale-down
            position: absolute
            top: 0
            left: 0
            // transition: .5s
        cursor: pointer
  .mb-answers-container
    width: 70%
    font-size: 24px
    right: 0
    // background: red
    .mb-answer-shadow
      transition: .5s
      margin: 30px
      box-sizing: border-box
      background: #ffffff
      // width: 200px
      max-width: calc(100% - 60px)
      // height: 200px
      box-shadow: 0 0 0 0px transparent,0 0 0 2px #0aabff, 0 0 0 16px #ffffff
      border-radius: 10px
      .mb-answer
        cursor: pointer
        width: 100%
        height: 100%
        display: flex
        align-items: center
        justify-content: flex-start
        padding: 14px
        background: transparent
        .mb-answer-img-box
          display: flex
          align-items: center
          justify-content: flex-start

          .mb-answer-img
            max-width: 100%
            padding: 10px
            max-height: 100%
            object-fit: scale-down


.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
